/*
 * metismenu - v2.4.0
 * A jQuery menu plugin
 * https://github.com/onokumus/metisMenu#readme
 *
 * Made by Osman Nuri Okumuş <onokumus@gmail.com> (https://github.com/onokumus)
 * Under MIT License
 */

/* eslint-disable */

// import jQuery from 'jquery';

!(function (a, b) {
  'function' == typeof define && define.amd
    ? define(['jquery'], b)
    : 'object' == typeof exports
    ? (module.exports = b(require('jquery')))
    : (a.sortable = b(a.jQuery));
})(this, function (a) {
  'use strict';
  function b() {
    var a = document.createElement('mm'),
      b = {
        WebkitTransition: 'webkitTransitionEnd',
        MozTransition: 'transitionend',
        OTransition: 'oTransitionEnd otransitionend',
        transition: 'transitionend',
      };
    for (var c in b) if (void 0 !== a.style[c]) return { end: b[c] };
    return !1;
  }
  function c(b) {
    return this.each(function () {
      var c = a(this),
        d = c.data('mm'),
        f = a.extend({}, e.DEFAULTS, c.data(), 'object' == typeof b && b);
      d || c.data('mm', (d = new e(this, f))), 'string' == typeof b && d[b]();
    });
  }
  a.fn.emulateTransitionEnd = function (b) {
    var c = !1,
      e = this;
    a(this).one('mmTransitionEnd', function () {
      c = !0;
    });
    var f = function () {
      c || a(e).trigger(d.end);
    };
    return setTimeout(f, b), this;
  };
  var d = b();
  d &&
    (a.event.special.mmTransitionEnd = {
      bindType: d.end,
      delegateType: d.end,
      handle: function (b) {
        return a(b.target).is(this)
          ? b.handleObj.handler.apply(this, arguments)
          : void 0;
      },
    });
  var e = function (b, c) {
    (this.$element = a(b)),
      (this.options = a.extend({}, e.DEFAULTS, c)),
      (this.transitioning = null),
      this.init();
  };
  (e.TRANSITION_DURATION = 350),
    (e.DEFAULTS = {
      toggle: !0,
      doubleTapToGo: !1,
      preventDefault: !0,
      activeClass: 'active',
      collapseClass: 'collapse',
      collapseInClass: 'in',
      collapsingClass: 'collapsing',
      onTransitionStart: !1,
      onTransitionEnd: !1,
    }),
    (e.prototype.init = function () {
      var b = this,
        c = this.options.activeClass,
        d = this.options.collapseClass,
        e = this.options.collapseInClass;
      this.$element
        .find('li.' + c)
        .has('ul')
        .children('ul')
        .attr('aria-expanded', !0)
        .addClass(d + ' ' + e),
        this.$element
          .find('li')
          .not('.' + c)
          .has('ul')
          .children('ul')
          .attr('aria-expanded', !1)
          .addClass(d),
        this.options.doubleTapToGo &&
          this.$element
            .find('li.' + c)
            .has('ul')
            .children('a')
            .addClass('doubleTapToGo'),
        this.$element
          .find('li')
          .has('ul')
          .children('a')
          .on('click.metisMenu', function (d) {
            var e = a(this),
              f = e.parent('li'),
              g = f.children('ul');
            return (
              b.options.preventDefault && d.preventDefault(),
              'true' !== e.attr('aria-disabled')
                ? (f.hasClass(c) && !b.options.doubleTapToGo
                    ? (b.hide(g), e.attr('aria-expanded', !1))
                    : (b.show(g), e.attr('aria-expanded', !0)),
                  b.options.onTransitionStart && b.options.onTransitionStart(),
                  b.options.doubleTapToGo &&
                  b.doubleTapToGo(e) &&
                  '#' !== e.attr('href') &&
                  '' !== e.attr('href')
                    ? (d.stopPropagation(),
                      void (document.location = e.attr('href')))
                    : void 0)
                : void 0
            );
          });
    }),
    (e.prototype.doubleTapToGo = function (a) {
      var b = this.$element;
      return a.hasClass('doubleTapToGo')
        ? (a.removeClass('doubleTapToGo'), !0)
        : a.parent().children('ul').length
        ? (b.find('.doubleTapToGo').removeClass('doubleTapToGo'),
          a.addClass('doubleTapToGo'),
          !1)
        : void 0;
    }),
    (e.prototype.show = function (b) {
      var c = this.options.activeClass,
        f = this.options.collapseClass,
        g = this.options.collapseInClass,
        h = this.options.collapsingClass,
        i = a(b),
        j = i.parent('li');
      if (!this.transitioning && !i.hasClass(g)) {
        j.addClass(c),
          this.options.toggle &&
            this.hide(
              j
                .siblings()
                .children('ul.' + g)
                .attr('aria-expanded', !1),
            ),
          i.removeClass(f).addClass(h).height(0),
          (this.transitioning = 1);
        var k = function () {
          this.transitioning &&
            this.options.onTransitionEnd &&
            this.options.onTransitionEnd(),
            i
              .removeClass(h)
              .addClass(f + ' ' + g)
              .height('')
              .attr('aria-expanded', !0),
            (this.transitioning = 0);
        };
        return d
          ? void i
              .one('mmTransitionEnd', a.proxy(k, this))
              .emulateTransitionEnd(e.TRANSITION_DURATION)
              .height(i[0].scrollHeight)
          : k.call(this);
      }
    }),
    (e.prototype.hide = function (b) {
      var c = this.options.activeClass,
        f = this.options.collapseClass,
        g = this.options.collapseInClass,
        h = this.options.collapsingClass,
        i = a(b);
      if (!this.transitioning && i.hasClass(g)) {
        i.parent('li').removeClass(c),
          i.height(i.height())[0].offsetHeight,
          i.addClass(h).removeClass(f).removeClass(g),
          (this.transitioning = 1);
        var j = function () {
          this.transitioning &&
            this.options.onTransitionEnd &&
            this.options.onTransitionEnd(),
            (this.transitioning = 0),
            i.removeClass(h).addClass(f).attr('aria-expanded', !1);
        };
        return d
          ? void i
              .height(0)
              .one('mmTransitionEnd', a.proxy(j, this))
              .emulateTransitionEnd(e.TRANSITION_DURATION)
          : j.call(this);
      }
    });
  var f = a.fn.metisMenu;
  (a.fn.metisMenu = c),
    (a.fn.metisMenu.Constructor = e),
    (a.fn.metisMenu.noConflict = function () {
      return (a.fn.metisMenu = f), this;
    });
});
